import React from 'react';
import EditBase from '@material-ui/icons/Create';

const Edit = (props) => <EditBase {...props} />;

export default Edit;
